import {domain} from '@/utils/domain'
import { Base64 } from 'js-base64'
export default {
  data() {
    return {

    }
  },
  methods: {
    // 筛选指定条件树状数据
    dealData(nodes, predicate) {
      // 如果已经没有节点了，结束递归
      if (!(nodes && nodes.length)) {
        return [];
      }
      const newChildren = [];
      for (const node of nodes) {
        if (predicate(node)) {
          // 如果节点符合条件，直接加入新的节点集
          newChildren.push(node);
          node.children = this.dealData(node.children, predicate);
        } else {
          // 如果当前节点不符合条件，递归过滤子节点，
          // 把符合条件的子节点提升上来，并入新节点集
          newChildren.push(...this.dealData(node.children, predicate));
        }
      }
      return newChildren;
    },
    // 限制输入框输入数字，zs：整数部分位数 xs: 小数部分位数
    limitControlLine (val, zs, xs) {
      let value = val;
      if (isNaN(val)) {
        value = String(val).replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
        value = value.replace(/\.{2,}/g, '.'); // 只保留第一个. 清除多余的
        value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      }
      if (value.charAt(0) === '0' && val.charAt(1) !== '.') {
        value = "0";
      }
      if (value.charAt(0) === '.') {
        value = "0." + value.split('.')[1] ;
      }
      if (Number(value) >Math.pow(10,zs)) {
        value = (value.split('.')[1] === undefined) ? value.substr(0,zs): value.substr(0,zs) + "." + value.split('.')[1];
      }
      if(value.indexOf('.')>0){
        value=value.slice(0,value.indexOf('.')+ (xs + 1));
      }
      return value;
    },
    // 预览附件公共方法
    commonPreviewAffix(file) {
      let url = file.filePath || file.url
      setTimeout(() => {
        window.open(`${domain.Preview_Domain}?url=${encodeURIComponent(Base64.encode(url))}`)
      })
    },
  }
}
